/**
 * Helper function to open an attachment in a new tab.
 * @param attachmentURL - The URL of the attachment to be opened.
 */
export const openAttachmentInNewTab = (attachmentURL: string) => {
  if (typeof window === "undefined") return;
  if (!attachmentURL?.trim()) return;

  const a = document.createElement("a");
  a.href = attachmentURL;
  a.rel = "noopener noreferrer";

  document.body.appendChild(a);
  a.click();
  a.remove();
};
